import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Work from "./pages/Work";
import Services from "./pages/Services";
import Insights from "./pages/Insights";
import Contact from "./pages/Contact";
import BrandingCaseStudy from "./pages/BrandingCaseStudy";
import AruhMarketingCaseStudy from "./pages/Marketing/AruhMarketingCaseStudy";

import Login from "./pages/login";

import Dashboard from "./admin/Dashboard";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminContact from "./admin/Contact";

function Layout() {
  const location = useLocation();

  const hideLayout =
    location.pathname === "/login" ||
    location.pathname.startsWith("/admin");

  return (
    <>
      {!hideLayout && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/work" element={<Work />} />
        <Route path="/brandingcasestudy" element={<BrandingCaseStudy />} />
        <Route path="/digitalcasestudy" element={<AruhMarketingCaseStudy />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/login" element={<Login />} />
         
        <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;